var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159, _circle160, _circle161, _circle162, _circle163, _circle164, _circle165, _circle166, _circle167, _circle168, _circle169, _circle170, _circle171, _circle172, _circle173, _circle174, _circle175, _circle176, _circle177, _circle178, _circle179, _circle180, _circle181, _circle182, _circle183, _circle184, _circle185, _circle186, _circle187, _circle188, _circle189, _circle190, _circle191, _circle192, _circle193, _circle194, _circle195, _circle196, _circle197, _circle198, _circle199, _circle200, _circle201, _circle202, _circle203, _circle204, _circle205, _circle206, _circle207, _circle208, _circle209, _circle210, _circle211, _circle212, _circle213, _circle214, _circle215, _circle216, _circle217, _circle218, _circle219, _circle220, _circle221, _circle222, _circle223, _circle224, _circle225, _circle226, _circle227, _circle228, _circle229, _circle230, _circle231, _circle232, _circle233, _circle234, _circle235, _circle236, _circle237, _circle238, _circle239, _circle240, _circle241, _circle242, _circle243, _circle244, _circle245, _circle246, _circle247, _circle248, _circle249, _circle250, _circle251, _circle252, _circle253, _circle254, _circle255, _circle256, _circle257, _circle258, _circle259, _circle260, _circle261, _circle262, _circle263, _circle264, _circle265, _circle266, _circle267, _circle268, _circle269, _circle270, _circle271, _circle272, _circle273, _circle274, _circle275, _circle276, _circle277, _circle278, _circle279, _circle280, _circle281, _circle282, _circle283, _circle284, _circle285, _circle286, _circle287, _circle288, _circle289, _circle290, _circle291, _circle292, _circle293, _circle294, _circle295, _circle296, _circle297, _circle298, _circle299, _circle300, _circle301, _circle302, _circle303, _circle304, _circle305, _circle306, _circle307, _circle308, _circle309, _circle310, _circle311, _circle312, _circle313, _circle314, _circle315, _circle316, _circle317, _circle318, _circle319, _circle320, _circle321, _circle322, _circle323, _circle324, _circle325, _circle326, _circle327, _circle328, _circle329, _circle330, _circle331, _circle332, _circle333, _circle334, _circle335, _circle336, _circle337, _circle338, _circle339, _circle340, _circle341, _circle342, _circle343, _circle344, _circle345, _circle346, _circle347, _circle348, _circle349, _circle350, _circle351, _circle352, _circle353, _circle354, _circle355, _circle356, _circle357, _circle358, _circle359, _circle360, _circle361, _circle362, _circle363, _circle364, _circle365, _circle366, _circle367, _circle368, _circle369, _circle370, _circle371, _circle372, _circle373, _circle374, _circle375, _circle376, _circle377, _circle378, _circle379, _circle380, _circle381, _circle382, _circle383, _circle384, _circle385, _circle386, _circle387, _circle388, _circle389, _circle390, _circle391, _circle392, _circle393, _circle394, _circle395, _circle396, _circle397, _circle398, _circle399, _circle400, _circle401, _circle402, _circle403, _circle404, _circle405, _circle406, _circle407, _circle408, _circle409, _circle410, _circle411, _circle412, _circle413, _circle414, _circle415, _circle416, _circle417, _circle418, _circle419, _circle420, _circle421, _circle422, _circle423, _circle424, _circle425, _circle426, _circle427, _circle428, _circle429, _circle430, _circle431, _circle432, _circle433, _circle434, _circle435, _circle436, _circle437, _circle438, _circle439, _circle440, _circle441, _circle442, _circle443, _circle444, _circle445, _circle446, _circle447, _circle448, _circle449, _circle450, _circle451, _circle452, _circle453, _circle454, _circle455, _circle456, _circle457, _circle458, _circle459, _circle460, _circle461, _circle462, _circle463, _circle464, _circle465, _circle466, _circle467, _circle468, _circle469, _circle470, _circle471, _circle472, _circle473, _circle474, _circle475, _circle476, _circle477, _circle478, _circle479, _circle480, _circle481, _circle482, _circle483, _circle484, _circle485, _circle486, _circle487, _circle488, _circle489, _circle490, _circle491, _circle492, _circle493, _circle494, _circle495, _circle496, _circle497, _circle498, _circle499, _circle500, _circle501, _circle502, _circle503, _circle504, _circle505, _circle506, _circle507, _circle508, _circle509, _circle510, _circle511, _circle512, _circle513, _circle514, _circle515, _circle516, _circle517, _circle518, _circle519, _circle520, _circle521, _circle522, _circle523, _circle524, _circle525, _circle526, _circle527, _circle528, _circle529, _circle530, _circle531, _circle532, _circle533, _circle534, _circle535, _circle536, _circle537, _circle538, _circle539, _circle540, _circle541, _circle542, _circle543, _circle544, _circle545, _circle546, _circle547, _circle548, _circle549, _circle550, _circle551, _circle552, _circle553, _circle554, _circle555, _circle556, _circle557, _circle558, _circle559, _circle560, _circle561, _circle562, _circle563, _circle564, _circle565, _circle566, _circle567, _circle568, _circle569, _circle570, _circle571, _circle572, _circle573, _circle574, _circle575, _circle576, _circle577, _circle578, _circle579, _circle580, _circle581, _circle582, _circle583, _circle584, _circle585, _circle586, _circle587, _circle588, _circle589, _circle590, _circle591, _circle592, _circle593, _circle594, _circle595, _circle596, _circle597, _circle598, _circle599, _circle600, _circle601, _circle602, _circle603, _circle604, _circle605, _circle606, _circle607, _circle608, _circle609, _circle610, _circle611, _circle612, _circle613, _circle614, _circle615, _circle616, _circle617, _circle618, _circle619, _circle620, _circle621, _circle622, _circle623, _circle624, _circle625, _circle626, _circle627, _circle628, _circle629, _circle630, _circle631, _circle632, _circle633, _circle634, _circle635, _circle636, _circle637, _circle638, _circle639, _circle640, _circle641, _circle642, _circle643, _circle644, _circle645, _circle646, _circle647, _circle648, _circle649, _circle650, _circle651, _circle652, _circle653, _circle654, _circle655, _circle656, _circle657, _circle658, _circle659, _circle660, _circle661, _circle662, _circle663, _circle664, _circle665, _circle666, _circle667, _circle668, _circle669, _circle670, _circle671, _circle672, _circle673, _circle674, _circle675, _circle676, _circle677, _circle678, _circle679, _circle680, _circle681, _circle682, _circle683, _circle684, _circle685, _circle686, _circle687, _circle688, _circle689, _circle690, _circle691, _circle692, _circle693, _circle694, _circle695, _circle696, _circle697, _circle698, _circle699, _circle700, _circle701, _circle702, _circle703, _circle704, _circle705, _circle706, _circle707, _circle708, _circle709, _circle710, _circle711, _circle712, _circle713, _circle714, _circle715, _circle716, _circle717, _circle718, _circle719, _circle720, _circle721, _circle722, _circle723, _circle724, _circle725, _circle726, _circle727, _circle728, _circle729, _circle730, _circle731, _circle732, _circle733, _circle734, _circle735, _circle736, _circle737, _circle738, _circle739, _circle740, _circle741, _circle742, _circle743, _circle744, _circle745, _circle746, _circle747, _circle748, _circle749, _circle750, _circle751, _circle752, _circle753, _circle754, _circle755, _circle756, _circle757, _circle758, _circle759, _circle760, _circle761, _circle762, _circle763, _circle764, _circle765, _circle766, _circle767, _circle768, _circle769, _circle770, _circle771, _circle772, _circle773, _circle774, _circle775, _circle776, _circle777, _circle778, _circle779, _circle780, _circle781, _circle782, _circle783, _circle784, _circle785, _circle786, _circle787, _circle788, _circle789, _circle790, _circle791, _circle792, _circle793, _circle794, _circle795, _circle796, _circle797, _circle798, _circle799, _circle800, _circle801, _circle802, _circle803, _circle804, _circle805, _circle806, _circle807, _circle808, _circle809, _circle810, _circle811, _circle812, _circle813, _circle814, _circle815, _circle816, _circle817, _circle818, _circle819, _circle820, _circle821, _circle822, _circle823, _circle824, _circle825, _circle826, _circle827, _circle828, _circle829, _circle830, _circle831, _circle832, _circle833, _circle834, _circle835, _circle836, _circle837, _circle838, _circle839, _circle840, _circle841, _circle842, _circle843, _circle844, _circle845, _circle846, _circle847, _circle848, _circle849, _circle850, _circle851, _circle852, _circle853, _circle854, _circle855, _circle856, _circle857, _circle858, _circle859, _circle860, _circle861, _circle862, _circle863, _circle864, _circle865, _circle866, _circle867, _circle868, _circle869, _circle870, _circle871, _circle872, _circle873, _circle874, _circle875, _circle876, _circle877, _circle878, _circle879, _circle880, _circle881, _circle882, _circle883, _circle884, _circle885, _circle886, _circle887, _circle888, _circle889, _circle890, _circle891, _circle892, _circle893, _circle894, _circle895, _circle896, _circle897, _circle898, _circle899, _circle900, _circle901, _circle902, _circle903, _circle904, _circle905, _circle906, _circle907, _circle908, _circle909, _circle910, _circle911, _circle912, _circle913, _circle914, _circle915, _circle916, _circle917, _circle918, _circle919, _circle920, _circle921, _circle922, _circle923, _circle924, _circle925, _circle926, _circle927, _circle928, _circle929, _circle930, _circle931, _circle932, _circle933, _circle934, _circle935, _circle936, _circle937, _circle938, _circle939, _circle940, _circle941, _circle942, _circle943, _circle944, _circle945, _circle946, _circle947, _circle948, _circle949, _circle950, _circle951, _circle952, _circle953, _circle954, _circle955, _circle956, _circle957, _circle958, _circle959, _circle960, _circle961, _circle962, _circle963, _circle964, _circle965, _circle966, _circle967, _circle968, _circle969, _circle970, _circle971, _circle972, _circle973, _circle974, _circle975, _circle976, _circle977, _circle978, _circle979, _circle980, _circle981, _circle982, _circle983, _circle984, _circle985, _circle986, _circle987, _circle988, _circle989, _circle990, _circle991, _circle992, _circle993, _circle994, _circle995, _circle996, _circle997, _circle998, _circle999, _circle1000, _circle1001, _circle1002, _circle1003, _circle1004, _circle1005, _circle1006, _circle1007, _circle1008, _circle1009, _circle1010, _circle1011, _circle1012, _circle1013, _circle1014, _circle1015, _circle1016, _circle1017, _circle1018, _circle1019, _circle1020, _circle1021, _circle1022, _circle1023, _circle1024, _circle1025, _circle1026, _circle1027, _circle1028, _circle1029, _circle1030, _circle1031, _circle1032, _circle1033, _circle1034, _circle1035, _circle1036, _circle1037, _circle1038, _circle1039, _circle1040, _circle1041, _circle1042, _circle1043, _circle1044, _circle1045, _circle1046, _circle1047, _circle1048, _circle1049, _circle1050, _circle1051, _circle1052, _circle1053, _circle1054, _circle1055, _circle1056, _circle1057, _circle1058, _circle1059, _circle1060, _circle1061, _circle1062, _circle1063, _circle1064, _circle1065, _circle1066, _circle1067, _circle1068, _circle1069, _circle1070, _circle1071, _circle1072, _circle1073, _circle1074, _circle1075, _circle1076, _circle1077, _circle1078, _circle1079, _circle1080, _circle1081, _circle1082, _circle1083, _circle1084, _circle1085, _circle1086, _circle1087, _circle1088, _circle1089, _circle1090, _circle1091, _circle1092, _circle1093, _circle1094, _circle1095, _circle1096, _circle1097, _circle1098, _circle1099, _circle1100, _circle1101, _circle1102, _circle1103, _circle1104, _circle1105, _circle1106, _circle1107, _circle1108, _circle1109, _circle1110, _circle1111, _circle1112, _circle1113, _circle1114, _circle1115, _circle1116, _circle1117, _circle1118, _circle1119, _circle1120, _circle1121, _circle1122, _circle1123, _circle1124, _circle1125, _circle1126, _circle1127, _circle1128, _circle1129, _circle1130, _circle1131, _circle1132, _circle1133, _circle1134, _circle1135, _circle1136, _circle1137, _circle1138, _circle1139, _circle1140, _circle1141, _circle1142, _circle1143, _circle1144, _circle1145, _circle1146, _circle1147, _circle1148, _circle1149, _circle1150, _circle1151, _circle1152, _circle1153, _circle1154, _circle1155, _circle1156, _circle1157, _circle1158, _circle1159, _circle1160, _circle1161, _circle1162, _circle1163, _circle1164, _circle1165, _circle1166, _circle1167, _circle1168, _circle1169, _circle1170, _circle1171, _circle1172, _circle1173, _circle1174, _circle1175, _circle1176, _circle1177, _circle1178, _circle1179, _circle1180, _circle1181, _circle1182, _circle1183, _circle1184, _circle1185, _circle1186, _circle1187, _circle1188, _circle1189, _circle1190, _circle1191, _circle1192, _circle1193, _circle1194, _circle1195, _circle1196, _circle1197, _circle1198, _circle1199, _circle1200, _circle1201, _circle1202, _circle1203, _circle1204, _circle1205, _circle1206, _circle1207, _circle1208, _circle1209, _circle1210, _circle1211, _circle1212, _circle1213, _circle1214, _circle1215, _circle1216, _circle1217, _circle1218, _circle1219, _circle1220, _circle1221, _circle1222, _circle1223, _circle1224, _circle1225, _circle1226, _circle1227, _circle1228, _circle1229, _circle1230, _circle1231, _circle1232, _circle1233, _circle1234, _circle1235, _circle1236, _circle1237, _circle1238, _circle1239, _circle1240, _circle1241, _circle1242, _circle1243, _circle1244, _circle1245, _circle1246, _circle1247, _circle1248, _circle1249, _circle1250, _circle1251, _circle1252, _circle1253, _circle1254, _circle1255, _circle1256, _circle1257, _circle1258, _circle1259, _circle1260, _circle1261, _circle1262, _circle1263, _circle1264, _circle1265, _circle1266, _circle1267, _circle1268, _circle1269, _circle1270, _circle1271, _circle1272, _circle1273, _circle1274, _circle1275, _circle1276, _circle1277, _circle1278, _circle1279, _circle1280, _circle1281, _circle1282, _circle1283, _circle1284, _circle1285, _circle1286, _circle1287, _circle1288, _circle1289, _circle1290, _circle1291, _circle1292, _circle1293, _circle1294, _circle1295, _circle1296, _circle1297, _circle1298, _circle1299, _circle1300, _circle1301, _circle1302, _circle1303, _circle1304, _circle1305, _circle1306, _circle1307, _circle1308, _circle1309, _circle1310, _circle1311, _circle1312, _circle1313, _circle1314, _circle1315, _circle1316, _circle1317, _circle1318, _circle1319, _circle1320, _circle1321, _circle1322, _circle1323, _circle1324, _circle1325, _circle1326, _circle1327, _circle1328, _circle1329, _circle1330, _circle1331, _circle1332, _circle1333, _circle1334, _circle1335, _circle1336, _circle1337, _circle1338, _circle1339, _circle1340, _circle1341, _circle1342, _circle1343, _circle1344, _circle1345, _circle1346, _circle1347, _circle1348, _circle1349, _circle1350, _circle1351, _circle1352, _circle1353, _circle1354, _circle1355, _circle1356, _circle1357, _circle1358, _circle1359, _circle1360, _circle1361, _circle1362, _circle1363, _circle1364, _circle1365, _circle1366, _circle1367, _circle1368, _circle1369, _circle1370, _circle1371, _circle1372, _circle1373, _circle1374, _circle1375, _circle1376, _circle1377, _circle1378, _circle1379, _circle1380, _circle1381, _circle1382, _circle1383, _circle1384, _circle1385, _circle1386, _circle1387, _circle1388, _circle1389, _circle1390, _circle1391, _circle1392, _circle1393, _circle1394, _circle1395, _circle1396, _circle1397, _circle1398, _circle1399, _circle1400, _circle1401, _circle1402, _circle1403, _circle1404, _circle1405, _circle1406, _circle1407, _circle1408, _circle1409, _circle1410, _circle1411, _circle1412, _circle1413, _circle1414, _circle1415, _circle1416, _circle1417, _circle1418, _circle1419, _circle1420, _circle1421, _circle1422, _circle1423, _circle1424, _circle1425, _circle1426, _circle1427, _circle1428, _circle1429, _circle1430, _circle1431, _circle1432, _circle1433, _circle1434, _circle1435, _circle1436, _circle1437, _circle1438, _circle1439, _circle1440, _circle1441, _circle1442, _circle1443, _circle1444, _circle1445, _circle1446, _circle1447, _circle1448, _circle1449, _circle1450, _circle1451, _circle1452, _circle1453, _circle1454, _circle1455, _circle1456, _circle1457, _circle1458, _circle1459, _circle1460, _circle1461, _circle1462, _circle1463, _circle1464, _circle1465, _circle1466, _circle1467, _circle1468, _circle1469, _circle1470, _circle1471, _circle1472, _circle1473, _circle1474, _circle1475, _circle1476, _circle1477, _circle1478, _circle1479, _circle1480, _circle1481, _circle1482, _circle1483, _circle1484, _circle1485, _circle1486, _circle1487, _circle1488, _circle1489, _circle1490, _circle1491, _circle1492, _circle1493, _circle1494, _circle1495, _circle1496, _circle1497, _circle1498, _circle1499, _circle1500, _circle1501, _circle1502, _circle1503, _circle1504, _circle1505, _circle1506, _circle1507, _circle1508, _circle1509, _circle1510, _circle1511, _circle1512, _circle1513, _circle1514, _circle1515, _circle1516, _circle1517, _circle1518, _circle1519, _circle1520, _circle1521, _circle1522, _circle1523, _circle1524, _circle1525, _circle1526, _circle1527, _circle1528, _circle1529, _circle1530, _circle1531, _circle1532, _circle1533, _circle1534, _circle1535, _circle1536, _circle1537, _circle1538, _circle1539, _circle1540, _circle1541, _circle1542, _circle1543, _circle1544, _circle1545, _circle1546, _circle1547, _circle1548, _circle1549, _circle1550, _circle1551, _circle1552, _circle1553, _circle1554, _circle1555, _circle1556, _circle1557, _circle1558, _circle1559, _circle1560, _circle1561, _circle1562, _circle1563, _circle1564, _circle1565, _circle1566, _circle1567, _circle1568, _circle1569, _circle1570, _circle1571, _circle1572, _circle1573, _circle1574, _circle1575, _circle1576, _circle1577, _circle1578, _circle1579, _circle1580, _circle1581, _circle1582, _circle1583, _circle1584, _circle1585, _circle1586, _circle1587, _circle1588, _circle1589, _circle1590, _circle1591, _circle1592, _circle1593, _circle1594, _circle1595, _circle1596, _circle1597, _circle1598, _circle1599, _circle1600, _circle1601, _circle1602, _circle1603, _circle1604, _circle1605, _circle1606, _circle1607, _circle1608, _circle1609, _circle1610, _circle1611, _circle1612, _circle1613, _circle1614, _circle1615, _circle1616, _circle1617, _circle1618, _circle1619, _circle1620, _circle1621, _circle1622, _circle1623, _circle1624, _circle1625, _circle1626, _circle1627, _circle1628, _circle1629, _circle1630, _circle1631, _circle1632, _circle1633, _circle1634, _circle1635, _circle1636, _circle1637, _circle1638, _circle1639, _circle1640, _circle1641, _circle1642, _circle1643, _circle1644, _circle1645, _circle1646, _circle1647, _circle1648, _circle1649, _circle1650, _circle1651, _circle1652, _circle1653, _circle1654, _circle1655, _circle1656, _circle1657, _circle1658, _circle1659, _circle1660, _circle1661, _circle1662, _circle1663, _circle1664, _circle1665, _circle1666, _circle1667, _circle1668, _circle1669, _circle1670, _circle1671, _circle1672, _circle1673, _circle1674, _circle1675, _circle1676, _circle1677, _circle1678, _circle1679, _circle1680, _circle1681, _circle1682, _circle1683, _circle1684, _circle1685, _circle1686, _circle1687, _circle1688, _circle1689, _circle1690, _circle1691, _circle1692, _circle1693, _circle1694, _circle1695, _circle1696, _circle1697, _circle1698, _circle1699, _circle1700, _circle1701, _circle1702, _circle1703, _circle1704, _circle1705, _circle1706, _circle1707, _circle1708, _circle1709, _circle1710, _circle1711, _circle1712, _circle1713, _circle1714, _circle1715, _circle1716, _circle1717, _circle1718, _circle1719, _circle1720, _circle1721, _circle1722, _circle1723, _circle1724, _circle1725, _circle1726, _circle1727, _circle1728, _circle1729, _circle1730, _circle1731, _circle1732, _circle1733, _circle1734, _circle1735, _circle1736, _circle1737, _circle1738, _circle1739, _circle1740, _circle1741, _circle1742, _circle1743, _circle1744, _circle1745, _circle1746, _circle1747, _circle1748, _circle1749, _circle1750, _circle1751, _circle1752, _circle1753, _circle1754, _circle1755, _circle1756, _circle1757, _circle1758, _circle1759, _circle1760, _circle1761, _circle1762, _circle1763, _circle1764, _circle1765, _circle1766, _circle1767, _circle1768, _circle1769, _circle1770, _circle1771, _circle1772, _circle1773, _circle1774, _circle1775, _circle1776, _circle1777, _circle1778, _circle1779, _circle1780, _circle1781, _circle1782, _circle1783, _circle1784, _circle1785, _circle1786, _circle1787, _circle1788, _circle1789, _circle1790, _circle1791, _circle1792, _circle1793, _circle1794, _circle1795, _circle1796, _circle1797, _circle1798, _circle1799, _circle1800, _circle1801, _circle1802, _circle1803, _circle1804, _circle1805, _circle1806, _circle1807, _circle1808, _circle1809, _circle1810, _circle1811, _circle1812, _circle1813, _circle1814, _circle1815, _circle1816, _circle1817, _circle1818, _circle1819, _circle1820, _circle1821, _circle1822, _circle1823, _circle1824, _circle1825, _circle1826, _circle1827, _circle1828, _circle1829, _circle1830, _circle1831, _circle1832, _circle1833, _circle1834, _circle1835, _circle1836, _circle1837, _circle1838, _circle1839, _circle1840, _g, _circle1841, _circle1842, _circle1843, _circle1844, _circle1845, _circle1846, _circle1847, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHero = function SvgHero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 536,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hero_svg__b",
    width: 1441,
    height: 536,
    x: -1,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__a)",
    d: "M-1 0h1441v536H-1z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#hero_svg__b)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 1385,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 1417,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    cx: 1349,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle163 || (_circle163 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle164 || (_circle164 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle165 || (_circle165 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle166 || (_circle166 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle167 || (_circle167 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle168 || (_circle168 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle169 || (_circle169 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle170 || (_circle170 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle171 || (_circle171 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle172 || (_circle172 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle173 || (_circle173 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle174 || (_circle174 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle175 || (_circle175 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle176 || (_circle176 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle177 || (_circle177 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle178 || (_circle178 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle179 || (_circle179 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle180 || (_circle180 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle181 || (_circle181 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle182 || (_circle182 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle183 || (_circle183 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle184 || (_circle184 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle185 || (_circle185 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle186 || (_circle186 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle187 || (_circle187 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle188 || (_circle188 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle189 || (_circle189 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle190 || (_circle190 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle191 || (_circle191 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle192 || (_circle192 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle193 || (_circle193 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle194 || (_circle194 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle195 || (_circle195 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle196 || (_circle196 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle197 || (_circle197 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle198 || (_circle198 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle199 || (_circle199 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle200 || (_circle200 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle201 || (_circle201 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle202 || (_circle202 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle203 || (_circle203 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle204 || (_circle204 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle205 || (_circle205 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle206 || (_circle206 = /*#__PURE__*/React.createElement("circle", {
    cx: 1329,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle207 || (_circle207 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle208 || (_circle208 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle209 || (_circle209 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle210 || (_circle210 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle211 || (_circle211 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle212 || (_circle212 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle213 || (_circle213 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle214 || (_circle214 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle215 || (_circle215 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle216 || (_circle216 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle217 || (_circle217 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle218 || (_circle218 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle219 || (_circle219 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle220 || (_circle220 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle221 || (_circle221 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle222 || (_circle222 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle223 || (_circle223 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle224 || (_circle224 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle225 || (_circle225 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle226 || (_circle226 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle227 || (_circle227 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle228 || (_circle228 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle229 || (_circle229 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle230 || (_circle230 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle231 || (_circle231 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle232 || (_circle232 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle233 || (_circle233 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle234 || (_circle234 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle235 || (_circle235 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle236 || (_circle236 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle237 || (_circle237 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle238 || (_circle238 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle239 || (_circle239 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle240 || (_circle240 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle241 || (_circle241 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle242 || (_circle242 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle243 || (_circle243 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle244 || (_circle244 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle245 || (_circle245 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle246 || (_circle246 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle247 || (_circle247 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle248 || (_circle248 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle249 || (_circle249 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle250 || (_circle250 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle251 || (_circle251 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle252 || (_circle252 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle253 || (_circle253 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle254 || (_circle254 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle255 || (_circle255 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle256 || (_circle256 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle257 || (_circle257 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle258 || (_circle258 = /*#__PURE__*/React.createElement("circle", {
    cx: 1309,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle259 || (_circle259 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle260 || (_circle260 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle261 || (_circle261 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle262 || (_circle262 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle263 || (_circle263 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle264 || (_circle264 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle265 || (_circle265 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle266 || (_circle266 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle267 || (_circle267 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle268 || (_circle268 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle269 || (_circle269 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle270 || (_circle270 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle271 || (_circle271 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle272 || (_circle272 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle273 || (_circle273 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle274 || (_circle274 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle275 || (_circle275 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle276 || (_circle276 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle277 || (_circle277 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle278 || (_circle278 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle279 || (_circle279 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle280 || (_circle280 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle281 || (_circle281 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle282 || (_circle282 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle283 || (_circle283 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle284 || (_circle284 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle285 || (_circle285 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle286 || (_circle286 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle287 || (_circle287 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle288 || (_circle288 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle289 || (_circle289 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle290 || (_circle290 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle291 || (_circle291 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle292 || (_circle292 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle293 || (_circle293 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle294 || (_circle294 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle295 || (_circle295 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle296 || (_circle296 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle297 || (_circle297 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle298 || (_circle298 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle299 || (_circle299 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle300 || (_circle300 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle301 || (_circle301 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle302 || (_circle302 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle303 || (_circle303 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle304 || (_circle304 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle305 || (_circle305 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle306 || (_circle306 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle307 || (_circle307 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle308 || (_circle308 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle309 || (_circle309 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle310 || (_circle310 = /*#__PURE__*/React.createElement("circle", {
    cx: 1289,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle311 || (_circle311 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle312 || (_circle312 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle313 || (_circle313 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle314 || (_circle314 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle315 || (_circle315 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle316 || (_circle316 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle317 || (_circle317 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle318 || (_circle318 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle319 || (_circle319 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle320 || (_circle320 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle321 || (_circle321 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle322 || (_circle322 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle323 || (_circle323 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle324 || (_circle324 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle325 || (_circle325 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle326 || (_circle326 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle327 || (_circle327 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle328 || (_circle328 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle329 || (_circle329 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle330 || (_circle330 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle331 || (_circle331 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle332 || (_circle332 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle333 || (_circle333 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle334 || (_circle334 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle335 || (_circle335 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle336 || (_circle336 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle337 || (_circle337 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle338 || (_circle338 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle339 || (_circle339 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle340 || (_circle340 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle341 || (_circle341 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle342 || (_circle342 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle343 || (_circle343 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle344 || (_circle344 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle345 || (_circle345 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle346 || (_circle346 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle347 || (_circle347 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle348 || (_circle348 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle349 || (_circle349 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle350 || (_circle350 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle351 || (_circle351 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle352 || (_circle352 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle353 || (_circle353 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle354 || (_circle354 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle355 || (_circle355 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle356 || (_circle356 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle357 || (_circle357 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle358 || (_circle358 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle359 || (_circle359 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle360 || (_circle360 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle361 || (_circle361 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle362 || (_circle362 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle363 || (_circle363 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle364 || (_circle364 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle365 || (_circle365 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle366 || (_circle366 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle367 || (_circle367 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle368 || (_circle368 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle369 || (_circle369 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle370 || (_circle370 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle371 || (_circle371 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle372 || (_circle372 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle373 || (_circle373 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle374 || (_circle374 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle375 || (_circle375 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle376 || (_circle376 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle377 || (_circle377 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle378 || (_circle378 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle379 || (_circle379 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle380 || (_circle380 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle381 || (_circle381 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle382 || (_circle382 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle383 || (_circle383 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle384 || (_circle384 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle385 || (_circle385 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle386 || (_circle386 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle387 || (_circle387 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle388 || (_circle388 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle389 || (_circle389 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle390 || (_circle390 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle391 || (_circle391 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle392 || (_circle392 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle393 || (_circle393 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle394 || (_circle394 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle395 || (_circle395 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle396 || (_circle396 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle397 || (_circle397 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle398 || (_circle398 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle399 || (_circle399 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle400 || (_circle400 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle401 || (_circle401 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle402 || (_circle402 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle403 || (_circle403 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle404 || (_circle404 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle405 || (_circle405 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle406 || (_circle406 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle407 || (_circle407 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle408 || (_circle408 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle409 || (_circle409 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle410 || (_circle410 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle411 || (_circle411 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle412 || (_circle412 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle413 || (_circle413 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle414 || (_circle414 = /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle415 || (_circle415 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle416 || (_circle416 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle417 || (_circle417 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle418 || (_circle418 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle419 || (_circle419 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle420 || (_circle420 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle421 || (_circle421 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle422 || (_circle422 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle423 || (_circle423 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle424 || (_circle424 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle425 || (_circle425 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle426 || (_circle426 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle427 || (_circle427 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle428 || (_circle428 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle429 || (_circle429 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle430 || (_circle430 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle431 || (_circle431 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle432 || (_circle432 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle433 || (_circle433 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle434 || (_circle434 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle435 || (_circle435 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle436 || (_circle436 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle437 || (_circle437 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle438 || (_circle438 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle439 || (_circle439 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle440 || (_circle440 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle441 || (_circle441 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle442 || (_circle442 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle443 || (_circle443 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle444 || (_circle444 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle445 || (_circle445 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle446 || (_circle446 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle447 || (_circle447 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle448 || (_circle448 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle449 || (_circle449 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle450 || (_circle450 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle451 || (_circle451 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle452 || (_circle452 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle453 || (_circle453 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle454 || (_circle454 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle455 || (_circle455 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle456 || (_circle456 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle457 || (_circle457 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle458 || (_circle458 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle459 || (_circle459 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle460 || (_circle460 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle461 || (_circle461 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle462 || (_circle462 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle463 || (_circle463 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle464 || (_circle464 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle465 || (_circle465 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle466 || (_circle466 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle467 || (_circle467 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle468 || (_circle468 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle469 || (_circle469 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle470 || (_circle470 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle471 || (_circle471 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle472 || (_circle472 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle473 || (_circle473 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle474 || (_circle474 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle475 || (_circle475 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle476 || (_circle476 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle477 || (_circle477 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle478 || (_circle478 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle479 || (_circle479 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle480 || (_circle480 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle481 || (_circle481 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle482 || (_circle482 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle483 || (_circle483 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle484 || (_circle484 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle485 || (_circle485 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle486 || (_circle486 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle487 || (_circle487 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle488 || (_circle488 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle489 || (_circle489 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle490 || (_circle490 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle491 || (_circle491 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle492 || (_circle492 = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle493 || (_circle493 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle494 || (_circle494 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle495 || (_circle495 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle496 || (_circle496 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle497 || (_circle497 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle498 || (_circle498 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle499 || (_circle499 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle500 || (_circle500 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle501 || (_circle501 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle502 || (_circle502 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle503 || (_circle503 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle504 || (_circle504 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle505 || (_circle505 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle506 || (_circle506 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle507 || (_circle507 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle508 || (_circle508 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle509 || (_circle509 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle510 || (_circle510 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle511 || (_circle511 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle512 || (_circle512 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle513 || (_circle513 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle514 || (_circle514 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle515 || (_circle515 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle516 || (_circle516 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle517 || (_circle517 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle518 || (_circle518 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle519 || (_circle519 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle520 || (_circle520 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle521 || (_circle521 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle522 || (_circle522 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle523 || (_circle523 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle524 || (_circle524 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle525 || (_circle525 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle526 || (_circle526 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle527 || (_circle527 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle528 || (_circle528 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle529 || (_circle529 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle530 || (_circle530 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle531 || (_circle531 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle532 || (_circle532 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle533 || (_circle533 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle534 || (_circle534 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle535 || (_circle535 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle536 || (_circle536 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle537 || (_circle537 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle538 || (_circle538 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle539 || (_circle539 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle540 || (_circle540 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle541 || (_circle541 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle542 || (_circle542 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle543 || (_circle543 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle544 || (_circle544 = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle545 || (_circle545 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle546 || (_circle546 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle547 || (_circle547 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle548 || (_circle548 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle549 || (_circle549 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle550 || (_circle550 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle551 || (_circle551 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle552 || (_circle552 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle553 || (_circle553 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__c)"
  }, _circle554 || (_circle554 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 198,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 198,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__d)"
  }, _circle555 || (_circle555 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 218,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 218,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__e)"
  }, _circle556 || (_circle556 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 238,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 238,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__f)"
  }, _circle557 || (_circle557 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 258,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 258,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__g)"
  }, _circle558 || (_circle558 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 278,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 278,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__h)"
  }, _circle559 || (_circle559 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 298,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 298,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__i)"
  }, _circle560 || (_circle560 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 318,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 318,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__j)"
  }, _circle561 || (_circle561 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 338,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 338,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle562 || (_circle562 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle563 || (_circle563 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle564 || (_circle564 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle565 || (_circle565 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle566 || (_circle566 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle567 || (_circle567 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle568 || (_circle568 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle569 || (_circle569 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle570 || (_circle570 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle571 || (_circle571 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle572 || (_circle572 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle573 || (_circle573 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle574 || (_circle574 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle575 || (_circle575 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle576 || (_circle576 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle577 || (_circle577 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle578 || (_circle578 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle579 || (_circle579 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__k)"
  }, _circle580 || (_circle580 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 198,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 198,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle581 || (_circle581 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle582 || (_circle582 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle583 || (_circle583 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle584 || (_circle584 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle585 || (_circle585 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle586 || (_circle586 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__l)"
  }, _circle587 || (_circle587 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 338,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 338,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__m)"
  }, _circle588 || (_circle588 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 358,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 358,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__n)"
  }, _circle589 || (_circle589 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 398,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 398,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__o)"
  }, _circle590 || (_circle590 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 418,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 418,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__p)"
  }, _circle591 || (_circle591 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 438,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 438,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__q)"
  }, _circle592 || (_circle592 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 458,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 458,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__r)"
  }, _circle593 || (_circle593 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 478,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 478,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle594 || (_circle594 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle595 || (_circle595 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle596 || (_circle596 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle597 || (_circle597 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle598 || (_circle598 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle599 || (_circle599 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle600 || (_circle600 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle601 || (_circle601 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle602 || (_circle602 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__s)"
  }, _circle603 || (_circle603 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 158,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 158,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__t)"
  }, _circle604 || (_circle604 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 178,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 178,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__u)"
  }, _circle605 || (_circle605 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 198,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 198,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle606 || (_circle606 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle607 || (_circle607 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle608 || (_circle608 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle609 || (_circle609 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle610 || (_circle610 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle611 || (_circle611 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle612 || (_circle612 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle613 || (_circle613 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle614 || (_circle614 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle615 || (_circle615 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle616 || (_circle616 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle617 || (_circle617 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle618 || (_circle618 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__v)"
  }, _circle619 || (_circle619 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 478,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 478,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle620 || (_circle620 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle621 || (_circle621 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle622 || (_circle622 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle623 || (_circle623 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle624 || (_circle624 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle625 || (_circle625 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle626 || (_circle626 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__w)"
  }, _circle627 || (_circle627 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 118,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 118,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__x)"
  }, _circle628 || (_circle628 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 138,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 138,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__y)"
  }, _circle629 || (_circle629 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 158,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 158,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle630 || (_circle630 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle631 || (_circle631 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle632 || (_circle632 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle633 || (_circle633 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle634 || (_circle634 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle635 || (_circle635 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle636 || (_circle636 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle637 || (_circle637 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle638 || (_circle638 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle639 || (_circle639 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle640 || (_circle640 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle641 || (_circle641 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle642 || (_circle642 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle643 || (_circle643 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle644 || (_circle644 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__z)"
  }, _circle645 || (_circle645 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 478,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 478,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle646 || (_circle646 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle647 || (_circle647 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle648 || (_circle648 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle649 || (_circle649 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle650 || (_circle650 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle651 || (_circle651 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__A)"
  }, _circle652 || (_circle652 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 98,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 98,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__B)"
  }, _circle653 || (_circle653 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 118,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 118,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle654 || (_circle654 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle655 || (_circle655 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle656 || (_circle656 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle657 || (_circle657 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle658 || (_circle658 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle659 || (_circle659 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle660 || (_circle660 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle661 || (_circle661 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle662 || (_circle662 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle663 || (_circle663 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle664 || (_circle664 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle665 || (_circle665 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle666 || (_circle666 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle667 || (_circle667 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle668 || (_circle668 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle669 || (_circle669 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle670 || (_circle670 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__C)"
  }, _circle671 || (_circle671 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 478,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 478,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle672 || (_circle672 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle673 || (_circle673 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle674 || (_circle674 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle675 || (_circle675 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle676 || (_circle676 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle677 || (_circle677 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle678 || (_circle678 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle679 || (_circle679 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle680 || (_circle680 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle681 || (_circle681 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle682 || (_circle682 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle683 || (_circle683 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle684 || (_circle684 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle685 || (_circle685 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle686 || (_circle686 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle687 || (_circle687 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle688 || (_circle688 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle689 || (_circle689 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle690 || (_circle690 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle691 || (_circle691 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle692 || (_circle692 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle693 || (_circle693 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle694 || (_circle694 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle695 || (_circle695 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle696 || (_circle696 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__D)"
  }, _circle697 || (_circle697 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 478,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 478,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle698 || (_circle698 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle699 || (_circle699 = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle700 || (_circle700 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle701 || (_circle701 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle702 || (_circle702 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle703 || (_circle703 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle704 || (_circle704 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle705 || (_circle705 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle706 || (_circle706 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle707 || (_circle707 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle708 || (_circle708 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle709 || (_circle709 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle710 || (_circle710 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle711 || (_circle711 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle712 || (_circle712 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle713 || (_circle713 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle714 || (_circle714 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle715 || (_circle715 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle716 || (_circle716 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle717 || (_circle717 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle718 || (_circle718 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle719 || (_circle719 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle720 || (_circle720 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle721 || (_circle721 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle722 || (_circle722 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__E)"
  }, _circle723 || (_circle723 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 478,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 478,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle724 || (_circle724 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle725 || (_circle725 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle726 || (_circle726 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle727 || (_circle727 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle728 || (_circle728 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle729 || (_circle729 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle730 || (_circle730 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle731 || (_circle731 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle732 || (_circle732 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle733 || (_circle733 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle734 || (_circle734 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle735 || (_circle735 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle736 || (_circle736 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle737 || (_circle737 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle738 || (_circle738 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle739 || (_circle739 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle740 || (_circle740 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle741 || (_circle741 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle742 || (_circle742 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle743 || (_circle743 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle744 || (_circle744 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle745 || (_circle745 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle746 || (_circle746 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle747 || (_circle747 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle748 || (_circle748 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__F)"
  }, _circle749 || (_circle749 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 478,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 478,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle750 || (_circle750 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle751 || (_circle751 = /*#__PURE__*/React.createElement("circle", {
    cx: 389,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle752 || (_circle752 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle753 || (_circle753 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle754 || (_circle754 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle755 || (_circle755 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle756 || (_circle756 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle757 || (_circle757 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle758 || (_circle758 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle759 || (_circle759 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle760 || (_circle760 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle761 || (_circle761 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle762 || (_circle762 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle763 || (_circle763 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle764 || (_circle764 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle765 || (_circle765 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle766 || (_circle766 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle767 || (_circle767 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle768 || (_circle768 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle769 || (_circle769 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle770 || (_circle770 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle771 || (_circle771 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle772 || (_circle772 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle773 || (_circle773 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle774 || (_circle774 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__G)"
  }, _circle775 || (_circle775 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 478,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 478,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle776 || (_circle776 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle777 || (_circle777 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle778 || (_circle778 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle779 || (_circle779 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle780 || (_circle780 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle781 || (_circle781 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle782 || (_circle782 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle783 || (_circle783 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle784 || (_circle784 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle785 || (_circle785 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle786 || (_circle786 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle787 || (_circle787 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle788 || (_circle788 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle789 || (_circle789 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle790 || (_circle790 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle791 || (_circle791 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle792 || (_circle792 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle793 || (_circle793 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle794 || (_circle794 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle795 || (_circle795 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle796 || (_circle796 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle797 || (_circle797 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle798 || (_circle798 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle799 || (_circle799 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle800 || (_circle800 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle801 || (_circle801 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle802 || (_circle802 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle803 || (_circle803 = /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle804 || (_circle804 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle805 || (_circle805 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle806 || (_circle806 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle807 || (_circle807 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle808 || (_circle808 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle809 || (_circle809 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle810 || (_circle810 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle811 || (_circle811 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle812 || (_circle812 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle813 || (_circle813 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle814 || (_circle814 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle815 || (_circle815 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle816 || (_circle816 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle817 || (_circle817 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle818 || (_circle818 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle819 || (_circle819 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle820 || (_circle820 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle821 || (_circle821 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle822 || (_circle822 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle823 || (_circle823 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle824 || (_circle824 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle825 || (_circle825 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle826 || (_circle826 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle827 || (_circle827 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle828 || (_circle828 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle829 || (_circle829 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle830 || (_circle830 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle831 || (_circle831 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle832 || (_circle832 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle833 || (_circle833 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle834 || (_circle834 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle835 || (_circle835 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle836 || (_circle836 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle837 || (_circle837 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle838 || (_circle838 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle839 || (_circle839 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle840 || (_circle840 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle841 || (_circle841 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle842 || (_circle842 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle843 || (_circle843 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle844 || (_circle844 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle845 || (_circle845 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle846 || (_circle846 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle847 || (_circle847 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle848 || (_circle848 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle849 || (_circle849 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle850 || (_circle850 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle851 || (_circle851 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle852 || (_circle852 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle853 || (_circle853 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle854 || (_circle854 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle855 || (_circle855 = /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle856 || (_circle856 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle857 || (_circle857 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle858 || (_circle858 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle859 || (_circle859 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle860 || (_circle860 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle861 || (_circle861 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle862 || (_circle862 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle863 || (_circle863 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle864 || (_circle864 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle865 || (_circle865 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle866 || (_circle866 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle867 || (_circle867 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle868 || (_circle868 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle869 || (_circle869 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle870 || (_circle870 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle871 || (_circle871 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle872 || (_circle872 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle873 || (_circle873 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle874 || (_circle874 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle875 || (_circle875 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle876 || (_circle876 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle877 || (_circle877 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle878 || (_circle878 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle879 || (_circle879 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle880 || (_circle880 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle881 || (_circle881 = /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle882 || (_circle882 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle883 || (_circle883 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle884 || (_circle884 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle885 || (_circle885 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle886 || (_circle886 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle887 || (_circle887 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle888 || (_circle888 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle889 || (_circle889 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle890 || (_circle890 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle891 || (_circle891 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle892 || (_circle892 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle893 || (_circle893 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle894 || (_circle894 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle895 || (_circle895 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle896 || (_circle896 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle897 || (_circle897 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle898 || (_circle898 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle899 || (_circle899 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle900 || (_circle900 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle901 || (_circle901 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle902 || (_circle902 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle903 || (_circle903 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle904 || (_circle904 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle905 || (_circle905 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle906 || (_circle906 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle907 || (_circle907 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle908 || (_circle908 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle909 || (_circle909 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle910 || (_circle910 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle911 || (_circle911 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle912 || (_circle912 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle913 || (_circle913 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle914 || (_circle914 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle915 || (_circle915 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle916 || (_circle916 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle917 || (_circle917 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle918 || (_circle918 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle919 || (_circle919 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle920 || (_circle920 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle921 || (_circle921 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle922 || (_circle922 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle923 || (_circle923 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle924 || (_circle924 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle925 || (_circle925 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 358,
    r: 2,
    fill: "#3A6352"
  })), _circle926 || (_circle926 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 378,
    r: 2,
    fill: "#3A6352"
  })), _circle927 || (_circle927 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 398,
    r: 2,
    fill: "#3A6352"
  })), _circle928 || (_circle928 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 418,
    r: 2,
    fill: "#3A6352"
  })), _circle929 || (_circle929 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 438,
    r: 2,
    fill: "#3A6352"
  })), _circle930 || (_circle930 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 458,
    r: 2,
    fill: "#3A6352"
  })), _circle931 || (_circle931 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 478,
    r: 2,
    fill: "#3A6352"
  })), _circle932 || (_circle932 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 498,
    r: 2,
    fill: "#3A6352"
  })), _circle933 || (_circle933 = /*#__PURE__*/React.createElement("circle", {
    cx: 529,
    cy: 518,
    r: 2,
    fill: "#3A6352"
  })), _circle934 || (_circle934 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle935 || (_circle935 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle936 || (_circle936 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle937 || (_circle937 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle938 || (_circle938 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle939 || (_circle939 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle940 || (_circle940 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle941 || (_circle941 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle942 || (_circle942 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle943 || (_circle943 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle944 || (_circle944 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle945 || (_circle945 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle946 || (_circle946 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle947 || (_circle947 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle948 || (_circle948 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle949 || (_circle949 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle950 || (_circle950 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle951 || (_circle951 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 358,
    r: 2,
    fill: "#3A6352"
  })), _circle952 || (_circle952 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 378,
    r: 2,
    fill: "#3A6352"
  })), _circle953 || (_circle953 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 398,
    r: 2,
    fill: "#3A6352"
  })), _circle954 || (_circle954 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 418,
    r: 2,
    fill: "#3A6352"
  })), _circle955 || (_circle955 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 438,
    r: 2,
    fill: "#3A6352"
  })), _circle956 || (_circle956 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 458,
    r: 2,
    fill: "#3A6352"
  })), _circle957 || (_circle957 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 478,
    r: 2,
    fill: "#3A6352"
  })), _circle958 || (_circle958 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 498,
    r: 2,
    fill: "#3A6352"
  })), _circle959 || (_circle959 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 518,
    r: 2,
    fill: "#3A6352"
  })), _circle960 || (_circle960 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle961 || (_circle961 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle962 || (_circle962 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle963 || (_circle963 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle964 || (_circle964 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle965 || (_circle965 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle966 || (_circle966 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle967 || (_circle967 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle968 || (_circle968 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle969 || (_circle969 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle970 || (_circle970 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle971 || (_circle971 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle972 || (_circle972 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle973 || (_circle973 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle974 || (_circle974 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle975 || (_circle975 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle976 || (_circle976 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle977 || (_circle977 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 358,
    r: 2,
    fill: "#3A6352"
  })), _circle978 || (_circle978 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 378,
    r: 2,
    fill: "#3A6352"
  })), _circle979 || (_circle979 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 398,
    r: 2,
    fill: "#3A6352"
  })), _circle980 || (_circle980 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 418,
    r: 2,
    fill: "#3A6352"
  })), _circle981 || (_circle981 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 438,
    r: 2,
    fill: "#3A6352"
  })), _circle982 || (_circle982 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 458,
    r: 2,
    fill: "#3A6352"
  })), _circle983 || (_circle983 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 478,
    r: 2,
    fill: "#3A6352"
  })), _circle984 || (_circle984 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 498,
    r: 2,
    fill: "#3A6352"
  })), _circle985 || (_circle985 = /*#__PURE__*/React.createElement("circle", {
    cx: 569,
    cy: 518,
    r: 2,
    fill: "#3A6352"
  })), _circle986 || (_circle986 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle987 || (_circle987 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle988 || (_circle988 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle989 || (_circle989 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle990 || (_circle990 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle991 || (_circle991 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle992 || (_circle992 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle993 || (_circle993 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle994 || (_circle994 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle995 || (_circle995 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle996 || (_circle996 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle997 || (_circle997 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle998 || (_circle998 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle999 || (_circle999 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1000 || (_circle1000 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1001 || (_circle1001 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1002 || (_circle1002 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1003 || (_circle1003 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 358,
    r: 2,
    fill: "#3A6352"
  })), _circle1004 || (_circle1004 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 378,
    r: 2,
    fill: "#3A6352"
  })), _circle1005 || (_circle1005 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 398,
    r: 2,
    fill: "#3A6352"
  })), _circle1006 || (_circle1006 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 418,
    r: 2,
    fill: "#3A6352"
  })), _circle1007 || (_circle1007 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 438,
    r: 2,
    fill: "#3A6352"
  })), _circle1008 || (_circle1008 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 458,
    r: 2,
    fill: "#3A6352"
  })), _circle1009 || (_circle1009 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 478,
    r: 2,
    fill: "#3A6352"
  })), _circle1010 || (_circle1010 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 498,
    r: 2,
    fill: "#3A6352"
  })), _circle1011 || (_circle1011 = /*#__PURE__*/React.createElement("circle", {
    cx: 589,
    cy: 518,
    r: 2,
    fill: "#3A6352"
  })), _circle1012 || (_circle1012 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1013 || (_circle1013 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1014 || (_circle1014 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1015 || (_circle1015 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1016 || (_circle1016 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1017 || (_circle1017 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1018 || (_circle1018 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1019 || (_circle1019 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1020 || (_circle1020 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1021 || (_circle1021 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1022 || (_circle1022 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1023 || (_circle1023 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1024 || (_circle1024 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1025 || (_circle1025 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1026 || (_circle1026 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1027 || (_circle1027 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1028 || (_circle1028 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1029 || (_circle1029 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 358,
    r: 2,
    fill: "#3A6352"
  })), _circle1030 || (_circle1030 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 378,
    r: 2,
    fill: "#3A6352"
  })), _circle1031 || (_circle1031 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 398,
    r: 2,
    fill: "#3A6352"
  })), _circle1032 || (_circle1032 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 418,
    r: 2,
    fill: "#3A6352"
  })), _circle1033 || (_circle1033 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 438,
    r: 2,
    fill: "#3A6352"
  })), _circle1034 || (_circle1034 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 458,
    r: 2,
    fill: "#3A6352"
  })), _circle1035 || (_circle1035 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 478,
    r: 2,
    fill: "#3A6352"
  })), _circle1036 || (_circle1036 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 498,
    r: 2,
    fill: "#3A6352"
  })), _circle1037 || (_circle1037 = /*#__PURE__*/React.createElement("circle", {
    cx: 609,
    cy: 518,
    r: 2,
    fill: "#3A6352"
  })), _circle1038 || (_circle1038 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1039 || (_circle1039 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1040 || (_circle1040 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1041 || (_circle1041 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1042 || (_circle1042 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1043 || (_circle1043 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1044 || (_circle1044 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1045 || (_circle1045 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1046 || (_circle1046 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1047 || (_circle1047 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1048 || (_circle1048 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1049 || (_circle1049 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1050 || (_circle1050 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1051 || (_circle1051 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1052 || (_circle1052 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1053 || (_circle1053 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1054 || (_circle1054 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1055 || (_circle1055 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 358,
    r: 2,
    fill: "#3A6352"
  })), _circle1056 || (_circle1056 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 378,
    r: 2,
    fill: "#3A6352"
  })), _circle1057 || (_circle1057 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 398,
    r: 2,
    fill: "#3A6352"
  })), _circle1058 || (_circle1058 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 418,
    r: 2,
    fill: "#3A6352"
  })), _circle1059 || (_circle1059 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 438,
    r: 2,
    fill: "#3A6352"
  })), _circle1060 || (_circle1060 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 458,
    r: 2,
    fill: "#3A6352"
  })), _circle1061 || (_circle1061 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 478,
    r: 2,
    fill: "#3A6352"
  })), _circle1062 || (_circle1062 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 498,
    r: 2,
    fill: "#3A6352"
  })), _circle1063 || (_circle1063 = /*#__PURE__*/React.createElement("circle", {
    cx: 629,
    cy: 518,
    r: 2,
    fill: "#3A6352"
  })), _circle1064 || (_circle1064 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1065 || (_circle1065 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1066 || (_circle1066 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1067 || (_circle1067 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1068 || (_circle1068 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1069 || (_circle1069 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1070 || (_circle1070 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1071 || (_circle1071 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1072 || (_circle1072 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1073 || (_circle1073 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1074 || (_circle1074 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1075 || (_circle1075 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1076 || (_circle1076 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1077 || (_circle1077 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1078 || (_circle1078 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1079 || (_circle1079 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1080 || (_circle1080 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1081 || (_circle1081 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 358,
    r: 2,
    fill: "#3A6352"
  })), _circle1082 || (_circle1082 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 378,
    r: 2,
    fill: "#3A6352"
  })), _circle1083 || (_circle1083 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 398,
    r: 2,
    fill: "#3A6352"
  })), _circle1084 || (_circle1084 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 418,
    r: 2,
    fill: "#3A6352"
  })), _circle1085 || (_circle1085 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 438,
    r: 2,
    fill: "#3A6352"
  })), _circle1086 || (_circle1086 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 458,
    r: 2,
    fill: "#3A6352"
  })), _circle1087 || (_circle1087 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 478,
    r: 2,
    fill: "#3A6352"
  })), _circle1088 || (_circle1088 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 498,
    r: 2,
    fill: "#3A6352"
  })), _circle1089 || (_circle1089 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 518,
    r: 2,
    fill: "#3A6352"
  })), _circle1090 || (_circle1090 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1091 || (_circle1091 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__H)"
  }, _circle1092 || (_circle1092 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 58,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 58,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle1093 || (_circle1093 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1094 || (_circle1094 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1095 || (_circle1095 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1096 || (_circle1096 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1097 || (_circle1097 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1098 || (_circle1098 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1099 || (_circle1099 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1100 || (_circle1100 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1101 || (_circle1101 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1102 || (_circle1102 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1103 || (_circle1103 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1104 || (_circle1104 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1105 || (_circle1105 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1106 || (_circle1106 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1107 || (_circle1107 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 358,
    r: 2,
    fill: "#3A6352"
  })), _circle1108 || (_circle1108 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 378,
    r: 2,
    fill: "#3A6352"
  })), _circle1109 || (_circle1109 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 398,
    r: 2,
    fill: "#3A6352"
  })), _circle1110 || (_circle1110 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 418,
    r: 2,
    fill: "#3A6352"
  })), _circle1111 || (_circle1111 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 438,
    r: 2,
    fill: "#3A6352"
  })), _circle1112 || (_circle1112 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 458,
    r: 2,
    fill: "#3A6352"
  })), _circle1113 || (_circle1113 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 478,
    r: 2,
    fill: "#3A6352"
  })), _circle1114 || (_circle1114 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 498,
    r: 2,
    fill: "#3A6352"
  })), _circle1115 || (_circle1115 = /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 518,
    r: 2,
    fill: "#3A6352"
  })), _circle1116 || (_circle1116 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1117 || (_circle1117 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1118 || (_circle1118 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__I)"
  }, _circle1119 || (_circle1119 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 78,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 78,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__J)"
  }, _circle1120 || (_circle1120 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 98,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 98,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle1121 || (_circle1121 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1122 || (_circle1122 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1123 || (_circle1123 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1124 || (_circle1124 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1125 || (_circle1125 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1126 || (_circle1126 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1127 || (_circle1127 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1128 || (_circle1128 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1129 || (_circle1129 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1130 || (_circle1130 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1131 || (_circle1131 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1132 || (_circle1132 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1133 || (_circle1133 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 358,
    r: 2,
    fill: "#3A6352"
  })), _circle1134 || (_circle1134 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 378,
    r: 2,
    fill: "#3A6352"
  })), _circle1135 || (_circle1135 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 398,
    r: 2,
    fill: "#3A6352"
  })), _circle1136 || (_circle1136 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 418,
    r: 2,
    fill: "#3A6352"
  })), _circle1137 || (_circle1137 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 438,
    r: 2,
    fill: "#3A6352"
  })), _circle1138 || (_circle1138 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 458,
    r: 2,
    fill: "#3A6352"
  })), _circle1139 || (_circle1139 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 478,
    r: 2,
    fill: "#3A6352"
  })), _circle1140 || (_circle1140 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 498,
    r: 2,
    fill: "#3A6352"
  })), _circle1141 || (_circle1141 = /*#__PURE__*/React.createElement("circle", {
    cx: 689,
    cy: 518,
    r: 2,
    fill: "#3A6352"
  })), _circle1142 || (_circle1142 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1143 || (_circle1143 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1144 || (_circle1144 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1145 || (_circle1145 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1146 || (_circle1146 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__K)"
  }, _circle1147 || (_circle1147 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 118,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 118,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__L)"
  }, _circle1148 || (_circle1148 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 138,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 138,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle1149 || (_circle1149 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1150 || (_circle1150 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1151 || (_circle1151 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1152 || (_circle1152 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1153 || (_circle1153 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1154 || (_circle1154 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1155 || (_circle1155 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1156 || (_circle1156 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1157 || (_circle1157 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1158 || (_circle1158 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1159 || (_circle1159 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 358,
    r: 2,
    fill: "#3A6352"
  })), _circle1160 || (_circle1160 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 378,
    r: 2,
    fill: "#3A6352"
  })), _circle1161 || (_circle1161 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 398,
    r: 2,
    fill: "#3A6352"
  })), _circle1162 || (_circle1162 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 418,
    r: 2,
    fill: "#3A6352"
  })), _circle1163 || (_circle1163 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 438,
    r: 2,
    fill: "#3A6352"
  })), _circle1164 || (_circle1164 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 458,
    r: 2,
    fill: "#3A6352"
  })), _circle1165 || (_circle1165 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 478,
    r: 2,
    fill: "#3A6352"
  })), _circle1166 || (_circle1166 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 498,
    r: 2,
    fill: "#3A6352"
  })), _circle1167 || (_circle1167 = /*#__PURE__*/React.createElement("circle", {
    cx: 709,
    cy: 518,
    r: 2,
    fill: "#3A6352"
  })), _circle1168 || (_circle1168 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1169 || (_circle1169 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1170 || (_circle1170 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1171 || (_circle1171 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1172 || (_circle1172 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1173 || (_circle1173 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__M)"
  }, _circle1174 || (_circle1174 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 158,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 158,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__N)"
  }, _circle1175 || (_circle1175 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 178,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 178,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle1176 || (_circle1176 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1177 || (_circle1177 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1178 || (_circle1178 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1179 || (_circle1179 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1180 || (_circle1180 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1181 || (_circle1181 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1182 || (_circle1182 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1183 || (_circle1183 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1184 || (_circle1184 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 358,
    r: 2,
    fill: "#3A6352"
  })), _circle1185 || (_circle1185 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 378,
    r: 2,
    fill: "#3A6352"
  })), _circle1186 || (_circle1186 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 398,
    r: 2,
    fill: "#3A6352"
  })), _circle1187 || (_circle1187 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 418,
    r: 2,
    fill: "#3A6352"
  })), _circle1188 || (_circle1188 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 438,
    r: 2,
    fill: "#3A6352"
  })), _circle1189 || (_circle1189 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 458,
    r: 2,
    fill: "#3A6352"
  })), _circle1190 || (_circle1190 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 478,
    r: 2,
    fill: "#3A6352"
  })), _circle1191 || (_circle1191 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 498,
    r: 2,
    fill: "#3A6352"
  })), _circle1192 || (_circle1192 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 518,
    r: 2,
    fill: "#3A6352"
  })), _circle1193 || (_circle1193 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1194 || (_circle1194 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1195 || (_circle1195 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1196 || (_circle1196 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1197 || (_circle1197 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1198 || (_circle1198 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1199 || (_circle1199 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1200 || (_circle1200 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__O)"
  }, _circle1201 || (_circle1201 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 178,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 178,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle1202 || (_circle1202 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1203 || (_circle1203 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1204 || (_circle1204 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1205 || (_circle1205 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1206 || (_circle1206 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1207 || (_circle1207 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1208 || (_circle1208 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1209 || (_circle1209 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1210 || (_circle1210 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 358,
    r: 2,
    fill: "#3A6352"
  })), _circle1211 || (_circle1211 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 378,
    r: 2,
    fill: "#3A6352"
  })), _circle1212 || (_circle1212 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 398,
    r: 2,
    fill: "#3A6352"
  })), _circle1213 || (_circle1213 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 418,
    r: 2,
    fill: "#3A6352"
  })), _circle1214 || (_circle1214 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 438,
    r: 2,
    fill: "#3A6352"
  })), _circle1215 || (_circle1215 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 458,
    r: 2,
    fill: "#3A6352"
  })), _circle1216 || (_circle1216 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 478,
    r: 2,
    fill: "#3A6352"
  })), _circle1217 || (_circle1217 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 498,
    r: 2,
    fill: "#3A6352"
  })), _circle1218 || (_circle1218 = /*#__PURE__*/React.createElement("circle", {
    cx: 749,
    cy: 518,
    r: 2,
    fill: "#3A6352"
  })), _circle1219 || (_circle1219 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1220 || (_circle1220 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1221 || (_circle1221 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1222 || (_circle1222 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1223 || (_circle1223 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1224 || (_circle1224 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1225 || (_circle1225 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1226 || (_circle1226 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__P)"
  }, _circle1227 || (_circle1227 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 178,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 178,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle1228 || (_circle1228 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1229 || (_circle1229 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1230 || (_circle1230 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1231 || (_circle1231 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1232 || (_circle1232 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1233 || (_circle1233 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1234 || (_circle1234 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1235 || (_circle1235 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1236 || (_circle1236 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 358,
    r: 2,
    fill: "#3A6352"
  })), _circle1237 || (_circle1237 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 378,
    r: 2,
    fill: "#3A6352"
  })), _circle1238 || (_circle1238 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 398,
    r: 2,
    fill: "#3A6352"
  })), _circle1239 || (_circle1239 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 418,
    r: 2,
    fill: "#3A6352"
  })), _circle1240 || (_circle1240 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 438,
    r: 2,
    fill: "#3A6352"
  })), _circle1241 || (_circle1241 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 458,
    r: 2,
    fill: "#3A6352"
  })), _circle1242 || (_circle1242 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 478,
    r: 2,
    fill: "#3A6352"
  })), _circle1243 || (_circle1243 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 498,
    r: 2,
    fill: "#3A6352"
  })), _circle1244 || (_circle1244 = /*#__PURE__*/React.createElement("circle", {
    cx: 769,
    cy: 518,
    r: 2,
    fill: "#3A6352"
  })), _circle1245 || (_circle1245 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1246 || (_circle1246 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1247 || (_circle1247 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1248 || (_circle1248 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1249 || (_circle1249 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1250 || (_circle1250 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1251 || (_circle1251 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1252 || (_circle1252 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__Q)",
    opacity: 0.6
  }, _circle1253 || (_circle1253 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 178,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 178,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle1254 || (_circle1254 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1255 || (_circle1255 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1256 || (_circle1256 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1257 || (_circle1257 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1258 || (_circle1258 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1259 || (_circle1259 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1260 || (_circle1260 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1261 || (_circle1261 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1262 || (_circle1262 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 358,
    r: 2,
    fill: "#3A6352"
  })), _circle1263 || (_circle1263 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 378,
    r: 2,
    fill: "#3A6352"
  })), _circle1264 || (_circle1264 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 398,
    r: 2,
    fill: "#3A6352"
  })), _circle1265 || (_circle1265 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 418,
    r: 2,
    fill: "#3A6352"
  })), _circle1266 || (_circle1266 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 438,
    r: 2,
    fill: "#3A6352"
  })), _circle1267 || (_circle1267 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 458,
    r: 2,
    fill: "#3A6352"
  })), _circle1268 || (_circle1268 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 478,
    r: 2,
    fill: "#3A6352"
  })), _circle1269 || (_circle1269 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 498,
    r: 2,
    fill: "#3A6352"
  })), _circle1270 || (_circle1270 = /*#__PURE__*/React.createElement("circle", {
    cx: 789,
    cy: 518,
    r: 2,
    fill: "#3A6352"
  })), _circle1271 || (_circle1271 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1272 || (_circle1272 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1273 || (_circle1273 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1274 || (_circle1274 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1275 || (_circle1275 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1276 || (_circle1276 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1277 || (_circle1277 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1278 || (_circle1278 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__R)",
    opacity: 0.8
  }, _circle1279 || (_circle1279 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 178,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 178,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle1280 || (_circle1280 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1281 || (_circle1281 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1282 || (_circle1282 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1283 || (_circle1283 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1284 || (_circle1284 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1285 || (_circle1285 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1286 || (_circle1286 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1287 || (_circle1287 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1288 || (_circle1288 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 358,
    r: 2,
    fill: "#3A6352"
  })), _circle1289 || (_circle1289 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 378,
    r: 2,
    fill: "#3A6352"
  })), _circle1290 || (_circle1290 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 398,
    r: 2,
    fill: "#3A6352"
  })), _circle1291 || (_circle1291 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 418,
    r: 2,
    fill: "#3A6352"
  })), _circle1292 || (_circle1292 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 438,
    r: 2,
    fill: "#3A6352"
  })), _circle1293 || (_circle1293 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 458,
    r: 2,
    fill: "#3A6352"
  })), _circle1294 || (_circle1294 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 478,
    r: 2,
    fill: "#3A6352"
  })), _circle1295 || (_circle1295 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 498,
    r: 2,
    fill: "#3A6352"
  })), _circle1296 || (_circle1296 = /*#__PURE__*/React.createElement("circle", {
    cx: 809,
    cy: 518,
    r: 2,
    fill: "#3A6352"
  })), _circle1297 || (_circle1297 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1298 || (_circle1298 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1299 || (_circle1299 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1300 || (_circle1300 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1301 || (_circle1301 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1302 || (_circle1302 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1303 || (_circle1303 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1304 || (_circle1304 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1305 || (_circle1305 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1306 || (_circle1306 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1307 || (_circle1307 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1308 || (_circle1308 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1309 || (_circle1309 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1310 || (_circle1310 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1311 || (_circle1311 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1312 || (_circle1312 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1313 || (_circle1313 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1314 || (_circle1314 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 358,
    r: 2,
    fill: "#3A6352"
  })), _circle1315 || (_circle1315 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 378,
    r: 2,
    fill: "#3A6352"
  })), _circle1316 || (_circle1316 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 398,
    r: 2,
    fill: "#3A6352"
  })), _circle1317 || (_circle1317 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 418,
    r: 2,
    fill: "#3A6352"
  })), _circle1318 || (_circle1318 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 438,
    r: 2,
    fill: "#3A6352"
  })), _circle1319 || (_circle1319 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 458,
    r: 2,
    fill: "#3A6352"
  })), _circle1320 || (_circle1320 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 478,
    r: 2,
    fill: "#3A6352"
  })), _circle1321 || (_circle1321 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 498,
    r: 2,
    fill: "#3A6352"
  })), _circle1322 || (_circle1322 = /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 518,
    r: 2,
    fill: "#3A6352"
  })), _circle1323 || (_circle1323 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1324 || (_circle1324 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1325 || (_circle1325 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1326 || (_circle1326 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1327 || (_circle1327 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1328 || (_circle1328 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1329 || (_circle1329 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1330 || (_circle1330 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1331 || (_circle1331 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1332 || (_circle1332 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1333 || (_circle1333 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1334 || (_circle1334 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1335 || (_circle1335 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1336 || (_circle1336 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1337 || (_circle1337 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1338 || (_circle1338 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1339 || (_circle1339 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1340 || (_circle1340 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 358,
    r: 2,
    fill: "#3A6352"
  })), _circle1341 || (_circle1341 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 378,
    r: 2,
    fill: "#3A6352"
  })), _circle1342 || (_circle1342 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 398,
    r: 2,
    fill: "#3A6352"
  })), _circle1343 || (_circle1343 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 418,
    r: 2,
    fill: "#3A6352"
  })), _circle1344 || (_circle1344 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 438,
    r: 2,
    fill: "#3A6352"
  })), _circle1345 || (_circle1345 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 458,
    r: 2,
    fill: "#3A6352"
  })), _circle1346 || (_circle1346 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 478,
    r: 2,
    fill: "#3A6352"
  })), _circle1347 || (_circle1347 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 498,
    r: 2,
    fill: "#3A6352"
  })), _circle1348 || (_circle1348 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 518,
    r: 2,
    fill: "#3A6352"
  })), _circle1349 || (_circle1349 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1350 || (_circle1350 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1351 || (_circle1351 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1352 || (_circle1352 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1353 || (_circle1353 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1354 || (_circle1354 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1355 || (_circle1355 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1356 || (_circle1356 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1357 || (_circle1357 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1358 || (_circle1358 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1359 || (_circle1359 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1360 || (_circle1360 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1361 || (_circle1361 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1362 || (_circle1362 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1363 || (_circle1363 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1364 || (_circle1364 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1365 || (_circle1365 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1366 || (_circle1366 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 358,
    r: 2,
    fill: "#3A6352"
  })), _circle1367 || (_circle1367 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 378,
    r: 2,
    fill: "#3A6352"
  })), _circle1368 || (_circle1368 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 398,
    r: 2,
    fill: "#3A6352"
  })), _circle1369 || (_circle1369 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 418,
    r: 2,
    fill: "#3A6352"
  })), _circle1370 || (_circle1370 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 438,
    r: 2,
    fill: "#3A6352"
  })), _circle1371 || (_circle1371 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 458,
    r: 2,
    fill: "#3A6352"
  })), _circle1372 || (_circle1372 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 478,
    r: 2,
    fill: "#3A6352"
  })), _circle1373 || (_circle1373 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 498,
    r: 2,
    fill: "#3A6352"
  })), _circle1374 || (_circle1374 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 518,
    r: 2,
    fill: "#3A6352"
  })), _circle1375 || (_circle1375 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1376 || (_circle1376 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1377 || (_circle1377 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1378 || (_circle1378 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1379 || (_circle1379 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1380 || (_circle1380 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1381 || (_circle1381 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1382 || (_circle1382 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1383 || (_circle1383 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1384 || (_circle1384 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1385 || (_circle1385 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1386 || (_circle1386 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1387 || (_circle1387 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1388 || (_circle1388 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1389 || (_circle1389 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1390 || (_circle1390 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1391 || (_circle1391 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1392 || (_circle1392 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 358,
    r: 2,
    fill: "#3A6352"
  })), _circle1393 || (_circle1393 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 378,
    r: 2,
    fill: "#3A6352"
  })), _circle1394 || (_circle1394 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 398,
    r: 2,
    fill: "#3A6352"
  })), _circle1395 || (_circle1395 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 418,
    r: 2,
    fill: "#3A6352"
  })), _circle1396 || (_circle1396 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 438,
    r: 2,
    fill: "#3A6352"
  })), _circle1397 || (_circle1397 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 458,
    r: 2,
    fill: "#3A6352"
  })), _circle1398 || (_circle1398 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 478,
    r: 2,
    fill: "#3A6352"
  })), _circle1399 || (_circle1399 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 498,
    r: 2,
    fill: "#3A6352"
  })), _circle1400 || (_circle1400 = /*#__PURE__*/React.createElement("circle", {
    cx: 889,
    cy: 518,
    r: 2,
    fill: "#3A6352"
  })), _circle1401 || (_circle1401 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1402 || (_circle1402 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1403 || (_circle1403 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1404 || (_circle1404 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1405 || (_circle1405 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1406 || (_circle1406 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1407 || (_circle1407 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1408 || (_circle1408 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1409 || (_circle1409 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1410 || (_circle1410 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1411 || (_circle1411 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1412 || (_circle1412 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1413 || (_circle1413 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1414 || (_circle1414 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1415 || (_circle1415 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1416 || (_circle1416 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1417 || (_circle1417 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1418 || (_circle1418 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 358,
    r: 2,
    fill: "#3A6352"
  })), _circle1419 || (_circle1419 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 378,
    r: 2,
    fill: "#3A6352"
  })), _circle1420 || (_circle1420 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 398,
    r: 2,
    fill: "#3A6352"
  })), _circle1421 || (_circle1421 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 418,
    r: 2,
    fill: "#3A6352"
  })), _circle1422 || (_circle1422 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 438,
    r: 2,
    fill: "#3A6352"
  })), _circle1423 || (_circle1423 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 458,
    r: 2,
    fill: "#3A6352"
  })), _circle1424 || (_circle1424 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 478,
    r: 2,
    fill: "#3A6352"
  })), _circle1425 || (_circle1425 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 498,
    r: 2,
    fill: "#3A6352"
  })), _circle1426 || (_circle1426 = /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 518,
    r: 2,
    fill: "#3A6352"
  })), _circle1427 || (_circle1427 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1428 || (_circle1428 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1429 || (_circle1429 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1430 || (_circle1430 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1431 || (_circle1431 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1432 || (_circle1432 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1433 || (_circle1433 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1434 || (_circle1434 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1435 || (_circle1435 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1436 || (_circle1436 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1437 || (_circle1437 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1438 || (_circle1438 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1439 || (_circle1439 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1440 || (_circle1440 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1441 || (_circle1441 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1442 || (_circle1442 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1443 || (_circle1443 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1444 || (_circle1444 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle1445 || (_circle1445 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle1446 || (_circle1446 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle1447 || (_circle1447 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle1448 || (_circle1448 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle1449 || (_circle1449 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle1450 || (_circle1450 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle1451 || (_circle1451 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle1452 || (_circle1452 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle1453 || (_circle1453 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1454 || (_circle1454 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1455 || (_circle1455 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1456 || (_circle1456 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1457 || (_circle1457 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1458 || (_circle1458 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1459 || (_circle1459 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1460 || (_circle1460 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1461 || (_circle1461 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1462 || (_circle1462 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1463 || (_circle1463 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1464 || (_circle1464 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1465 || (_circle1465 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1466 || (_circle1466 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1467 || (_circle1467 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1468 || (_circle1468 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1469 || (_circle1469 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1470 || (_circle1470 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle1471 || (_circle1471 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle1472 || (_circle1472 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle1473 || (_circle1473 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle1474 || (_circle1474 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle1475 || (_circle1475 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle1476 || (_circle1476 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle1477 || (_circle1477 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle1478 || (_circle1478 = /*#__PURE__*/React.createElement("circle", {
    cx: 949,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle1479 || (_circle1479 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1480 || (_circle1480 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1481 || (_circle1481 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1482 || (_circle1482 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1483 || (_circle1483 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1484 || (_circle1484 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1485 || (_circle1485 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1486 || (_circle1486 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1487 || (_circle1487 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1488 || (_circle1488 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1489 || (_circle1489 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1490 || (_circle1490 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1491 || (_circle1491 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1492 || (_circle1492 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1493 || (_circle1493 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1494 || (_circle1494 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1495 || (_circle1495 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1496 || (_circle1496 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle1497 || (_circle1497 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle1498 || (_circle1498 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle1499 || (_circle1499 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle1500 || (_circle1500 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle1501 || (_circle1501 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle1502 || (_circle1502 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle1503 || (_circle1503 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle1504 || (_circle1504 = /*#__PURE__*/React.createElement("circle", {
    cx: 969,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle1505 || (_circle1505 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1506 || (_circle1506 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1507 || (_circle1507 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1508 || (_circle1508 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1509 || (_circle1509 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1510 || (_circle1510 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1511 || (_circle1511 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1512 || (_circle1512 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1513 || (_circle1513 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1514 || (_circle1514 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1515 || (_circle1515 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1516 || (_circle1516 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1517 || (_circle1517 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1518 || (_circle1518 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1519 || (_circle1519 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1520 || (_circle1520 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1521 || (_circle1521 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1522 || (_circle1522 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle1523 || (_circle1523 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle1524 || (_circle1524 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle1525 || (_circle1525 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle1526 || (_circle1526 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle1527 || (_circle1527 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle1528 || (_circle1528 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle1529 || (_circle1529 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle1530 || (_circle1530 = /*#__PURE__*/React.createElement("circle", {
    cx: 989,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle1531 || (_circle1531 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1532 || (_circle1532 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1533 || (_circle1533 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1534 || (_circle1534 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1535 || (_circle1535 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1536 || (_circle1536 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1537 || (_circle1537 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1538 || (_circle1538 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1539 || (_circle1539 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1540 || (_circle1540 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1541 || (_circle1541 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1542 || (_circle1542 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1543 || (_circle1543 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1544 || (_circle1544 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1545 || (_circle1545 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1546 || (_circle1546 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1547 || (_circle1547 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1548 || (_circle1548 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle1549 || (_circle1549 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle1550 || (_circle1550 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle1551 || (_circle1551 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle1552 || (_circle1552 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle1553 || (_circle1553 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle1554 || (_circle1554 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle1555 || (_circle1555 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle1556 || (_circle1556 = /*#__PURE__*/React.createElement("circle", {
    cx: 1009,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle1557 || (_circle1557 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1558 || (_circle1558 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1559 || (_circle1559 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1560 || (_circle1560 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1561 || (_circle1561 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1562 || (_circle1562 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1563 || (_circle1563 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1564 || (_circle1564 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1565 || (_circle1565 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1566 || (_circle1566 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1567 || (_circle1567 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1568 || (_circle1568 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1569 || (_circle1569 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1570 || (_circle1570 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1571 || (_circle1571 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1572 || (_circle1572 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1573 || (_circle1573 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1574 || (_circle1574 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle1575 || (_circle1575 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle1576 || (_circle1576 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle1577 || (_circle1577 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle1578 || (_circle1578 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle1579 || (_circle1579 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle1580 || (_circle1580 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle1581 || (_circle1581 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle1582 || (_circle1582 = /*#__PURE__*/React.createElement("circle", {
    cx: 1029,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle1583 || (_circle1583 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1584 || (_circle1584 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1585 || (_circle1585 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1586 || (_circle1586 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1587 || (_circle1587 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1588 || (_circle1588 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1589 || (_circle1589 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1590 || (_circle1590 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1591 || (_circle1591 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1592 || (_circle1592 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1593 || (_circle1593 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1594 || (_circle1594 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1595 || (_circle1595 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1596 || (_circle1596 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1597 || (_circle1597 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1598 || (_circle1598 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1599 || (_circle1599 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1600 || (_circle1600 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle1601 || (_circle1601 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle1602 || (_circle1602 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle1603 || (_circle1603 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle1604 || (_circle1604 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle1605 || (_circle1605 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle1606 || (_circle1606 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle1607 || (_circle1607 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle1608 || (_circle1608 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle1609 || (_circle1609 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1610 || (_circle1610 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__S)"
  }, _circle1611 || (_circle1611 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 58,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 58,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle1612 || (_circle1612 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1613 || (_circle1613 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1614 || (_circle1614 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1615 || (_circle1615 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1616 || (_circle1616 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1617 || (_circle1617 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1618 || (_circle1618 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1619 || (_circle1619 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1620 || (_circle1620 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1621 || (_circle1621 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1622 || (_circle1622 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1623 || (_circle1623 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1624 || (_circle1624 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1625 || (_circle1625 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1626 || (_circle1626 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle1627 || (_circle1627 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle1628 || (_circle1628 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle1629 || (_circle1629 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle1630 || (_circle1630 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle1631 || (_circle1631 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle1632 || (_circle1632 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle1633 || (_circle1633 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle1634 || (_circle1634 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle1635 || (_circle1635 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1636 || (_circle1636 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__T)"
  }, _circle1637 || (_circle1637 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 58,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 58,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__U)"
  }, _circle1638 || (_circle1638 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 78,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 78,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle1639 || (_circle1639 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1640 || (_circle1640 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1641 || (_circle1641 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1642 || (_circle1642 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1643 || (_circle1643 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1644 || (_circle1644 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1645 || (_circle1645 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1646 || (_circle1646 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1647 || (_circle1647 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1648 || (_circle1648 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1649 || (_circle1649 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1650 || (_circle1650 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1651 || (_circle1651 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1652 || (_circle1652 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle1653 || (_circle1653 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle1654 || (_circle1654 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle1655 || (_circle1655 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle1656 || (_circle1656 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle1657 || (_circle1657 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle1658 || (_circle1658 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle1659 || (_circle1659 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle1660 || (_circle1660 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle1661 || (_circle1661 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1662 || (_circle1662 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1663 || (_circle1663 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__V)"
  }, _circle1664 || (_circle1664 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 78,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 78,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle1665 || (_circle1665 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1666 || (_circle1666 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1667 || (_circle1667 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1668 || (_circle1668 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1669 || (_circle1669 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1670 || (_circle1670 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1671 || (_circle1671 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1672 || (_circle1672 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1673 || (_circle1673 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1674 || (_circle1674 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1675 || (_circle1675 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1676 || (_circle1676 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1677 || (_circle1677 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1678 || (_circle1678 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle1679 || (_circle1679 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle1680 || (_circle1680 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle1681 || (_circle1681 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle1682 || (_circle1682 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle1683 || (_circle1683 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle1684 || (_circle1684 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle1685 || (_circle1685 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle1686 || (_circle1686 = /*#__PURE__*/React.createElement("circle", {
    cx: 1109,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle1687 || (_circle1687 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1688 || (_circle1688 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1689 || (_circle1689 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__W)"
  }, _circle1690 || (_circle1690 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 78,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 78,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle1691 || (_circle1691 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1692 || (_circle1692 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1693 || (_circle1693 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1694 || (_circle1694 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1695 || (_circle1695 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1696 || (_circle1696 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1697 || (_circle1697 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1698 || (_circle1698 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1699 || (_circle1699 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1700 || (_circle1700 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1701 || (_circle1701 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1702 || (_circle1702 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1703 || (_circle1703 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1704 || (_circle1704 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle1705 || (_circle1705 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle1706 || (_circle1706 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle1707 || (_circle1707 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle1708 || (_circle1708 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle1709 || (_circle1709 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle1710 || (_circle1710 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle1711 || (_circle1711 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle1712 || (_circle1712 = /*#__PURE__*/React.createElement("circle", {
    cx: 1129,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle1713 || (_circle1713 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1714 || (_circle1714 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1715 || (_circle1715 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__X)"
  }, _circle1716 || (_circle1716 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 78,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 78,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__Y)"
  }, _circle1717 || (_circle1717 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 98,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 98,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__Z)"
  }, _circle1718 || (_circle1718 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 118,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 118,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__aa)"
  }, _circle1719 || (_circle1719 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 178,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 178,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__ab)"
  }, _circle1720 || (_circle1720 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 198,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 198,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__ac)"
  }, _circle1721 || (_circle1721 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 218,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 218,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle1722 || (_circle1722 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1723 || (_circle1723 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1724 || (_circle1724 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1725 || (_circle1725 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1726 || (_circle1726 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1727 || (_circle1727 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1728 || (_circle1728 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle1729 || (_circle1729 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle1730 || (_circle1730 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle1731 || (_circle1731 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle1732 || (_circle1732 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle1733 || (_circle1733 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle1734 || (_circle1734 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle1735 || (_circle1735 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle1736 || (_circle1736 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle1737 || (_circle1737 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1738 || (_circle1738 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1739 || (_circle1739 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1740 || (_circle1740 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1741 || (_circle1741 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1742 || (_circle1742 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1743 || (_circle1743 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1744 || (_circle1744 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1745 || (_circle1745 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1746 || (_circle1746 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__ad)"
  }, _circle1747 || (_circle1747 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 218,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 218,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle1748 || (_circle1748 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1749 || (_circle1749 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1750 || (_circle1750 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1751 || (_circle1751 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1752 || (_circle1752 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1753 || (_circle1753 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1754 || (_circle1754 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle1755 || (_circle1755 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle1756 || (_circle1756 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle1757 || (_circle1757 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle1758 || (_circle1758 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle1759 || (_circle1759 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle1760 || (_circle1760 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle1761 || (_circle1761 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle1762 || (_circle1762 = /*#__PURE__*/React.createElement("circle", {
    cx: 1169,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle1763 || (_circle1763 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1764 || (_circle1764 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1765 || (_circle1765 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1766 || (_circle1766 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1767 || (_circle1767 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1768 || (_circle1768 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1769 || (_circle1769 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1770 || (_circle1770 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1771 || (_circle1771 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1772 || (_circle1772 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__ae)"
  }, _circle1773 || (_circle1773 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 218,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 218,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle1774 || (_circle1774 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1775 || (_circle1775 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), _circle1776 || (_circle1776 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 278,
    r: 2,
    fill: "#262626"
  })), _circle1777 || (_circle1777 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1778 || (_circle1778 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1779 || (_circle1779 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1780 || (_circle1780 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle1781 || (_circle1781 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle1782 || (_circle1782 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle1783 || (_circle1783 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle1784 || (_circle1784 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle1785 || (_circle1785 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle1786 || (_circle1786 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle1787 || (_circle1787 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle1788 || (_circle1788 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle1789 || (_circle1789 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1790 || (_circle1790 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1791 || (_circle1791 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1792 || (_circle1792 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1793 || (_circle1793 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1794 || (_circle1794 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1795 || (_circle1795 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1796 || (_circle1796 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1797 || (_circle1797 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1798 || (_circle1798 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__af)"
  }, _circle1799 || (_circle1799 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 218,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 218,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__ag)"
  }, _circle1800 || (_circle1800 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 238,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 238,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__ah)"
  }, _circle1801 || (_circle1801 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 258,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 258,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__ai)"
  }, _circle1802 || (_circle1802 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 278,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 278,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle1803 || (_circle1803 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1804 || (_circle1804 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1805 || (_circle1805 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1806 || (_circle1806 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle1807 || (_circle1807 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle1808 || (_circle1808 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle1809 || (_circle1809 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle1810 || (_circle1810 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle1811 || (_circle1811 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle1812 || (_circle1812 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle1813 || (_circle1813 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle1814 || (_circle1814 = /*#__PURE__*/React.createElement("circle", {
    cx: 1209,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _circle1815 || (_circle1815 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 18,
    r: 2,
    fill: "#262626"
  })), _circle1816 || (_circle1816 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 38,
    r: 2,
    fill: "#262626"
  })), _circle1817 || (_circle1817 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 58,
    r: 2,
    fill: "#262626"
  })), _circle1818 || (_circle1818 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 78,
    r: 2,
    fill: "#262626"
  })), _circle1819 || (_circle1819 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 98,
    r: 2,
    fill: "#262626"
  })), _circle1820 || (_circle1820 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 118,
    r: 2,
    fill: "#262626"
  })), _circle1821 || (_circle1821 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 138,
    r: 2,
    fill: "#262626"
  })), _circle1822 || (_circle1822 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 158,
    r: 2,
    fill: "#262626"
  })), _circle1823 || (_circle1823 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 178,
    r: 2,
    fill: "#262626"
  })), _circle1824 || (_circle1824 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 198,
    r: 2,
    fill: "#262626"
  })), _circle1825 || (_circle1825 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 218,
    r: 2,
    fill: "#262626"
  })), _circle1826 || (_circle1826 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 238,
    r: 2,
    fill: "#262626"
  })), _circle1827 || (_circle1827 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 258,
    r: 2,
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__aj)"
  }, _circle1828 || (_circle1828 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 278,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 278,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _circle1829 || (_circle1829 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 298,
    r: 2,
    fill: "#262626"
  })), _circle1830 || (_circle1830 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 318,
    r: 2,
    fill: "#262626"
  })), _circle1831 || (_circle1831 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 338,
    r: 2,
    fill: "#262626"
  })), _circle1832 || (_circle1832 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 358,
    r: 2,
    fill: "#262626"
  })), _circle1833 || (_circle1833 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 378,
    r: 2,
    fill: "#262626"
  })), _circle1834 || (_circle1834 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 398,
    r: 2,
    fill: "#262626"
  })), _circle1835 || (_circle1835 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 418,
    r: 2,
    fill: "#262626"
  })), _circle1836 || (_circle1836 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 438,
    r: 2,
    fill: "#262626"
  })), _circle1837 || (_circle1837 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 458,
    r: 2,
    fill: "#262626"
  })), _circle1838 || (_circle1838 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 478,
    r: 2,
    fill: "#262626"
  })), _circle1839 || (_circle1839 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 498,
    r: 2,
    fill: "#262626"
  })), _circle1840 || (_circle1840 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229,
    cy: 518,
    r: 2,
    fill: "#262626"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__ak)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__al)",
    d: "M-125 0h1689v536H-125z"
  }))))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__am)",
    opacity: 0.7
  }, _circle1841 || (_circle1841 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 158,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 158,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__an)",
    opacity: 0.3
  }, _circle1842 || (_circle1842 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 378,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 378,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__ao)",
    opacity: 0.5
  }, _circle1843 || (_circle1843 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 138,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 138,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__ap)",
    opacity: 0.05
  }, _circle1844 || (_circle1844 = /*#__PURE__*/React.createElement("circle", {
    cx: 1190,
    cy: 458,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1190,
    cy: 458,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__aq)",
    opacity: 0.1
  }, _circle1845 || (_circle1845 = /*#__PURE__*/React.createElement("circle", {
    cx: 1170,
    cy: 458,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1170,
    cy: 458,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__ar)",
    opacity: 0.15
  }, _circle1846 || (_circle1846 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 458,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 458,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hero_svg__as)",
    opacity: 0.6
  }, _circle1847 || (_circle1847 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 138,
    r: 2,
    fill: "#46DA93"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 138,
    r: 1.5,
    stroke: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__c",
    width: 35.2,
    height: 35.2,
    x: 231.4,
    y: 180.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__d",
    width: 35.2,
    height: 35.2,
    x: 231.4,
    y: 200.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__e",
    width: 35.2,
    height: 35.2,
    x: 231.4,
    y: 220.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__f",
    width: 35.2,
    height: 35.2,
    x: 231.4,
    y: 240.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__g",
    width: 35.2,
    height: 35.2,
    x: 231.4,
    y: 260.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__h",
    width: 35.2,
    height: 35.2,
    x: 231.4,
    y: 280.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__i",
    width: 35.2,
    height: 35.2,
    x: 231.4,
    y: 300.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__j",
    width: 35.2,
    height: 35.2,
    x: 231.4,
    y: 320.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__k",
    width: 35.2,
    height: 35.2,
    x: 251.4,
    y: 180.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__l",
    width: 35.2,
    height: 35.2,
    x: 251.4,
    y: 320.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__m",
    width: 35.2,
    height: 35.2,
    x: 251.4,
    y: 340.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__n",
    width: 35.2,
    height: 35.2,
    x: 251.4,
    y: 380.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__o",
    width: 35.2,
    height: 35.2,
    x: 251.4,
    y: 400.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__p",
    width: 35.2,
    height: 35.2,
    x: 251.4,
    y: 420.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__q",
    width: 35.2,
    height: 35.2,
    x: 251.4,
    y: 440.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__r",
    width: 35.2,
    height: 35.2,
    x: 251.4,
    y: 460.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__s",
    width: 35.2,
    height: 35.2,
    x: 271.4,
    y: 140.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__t",
    width: 35.2,
    height: 35.2,
    x: 271.4,
    y: 160.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__u",
    width: 35.2,
    height: 35.2,
    x: 271.4,
    y: 180.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__v",
    width: 35.2,
    height: 35.2,
    x: 271.4,
    y: 460.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__w",
    width: 35.2,
    height: 35.2,
    x: 291.4,
    y: 100.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__x",
    width: 35.2,
    height: 35.2,
    x: 291.4,
    y: 120.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__y",
    width: 35.2,
    height: 35.2,
    x: 291.4,
    y: 140.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__z",
    width: 35.2,
    height: 35.2,
    x: 291.4,
    y: 460.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__A",
    width: 35.2,
    height: 35.2,
    x: 311.4,
    y: 80.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__B",
    width: 35.2,
    height: 35.2,
    x: 311.4,
    y: 100.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__C",
    width: 35.2,
    height: 35.2,
    x: 311.4,
    y: 460.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__D",
    width: 35.2,
    height: 35.2,
    x: 331.4,
    y: 460.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__E",
    width: 35.2,
    height: 35.2,
    x: 351.4,
    y: 460.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__F",
    width: 35.2,
    height: 35.2,
    x: 371.4,
    y: 460.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__G",
    width: 35.2,
    height: 35.2,
    x: 391.4,
    y: 460.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__H",
    width: 35.2,
    height: 35.2,
    x: 651.4,
    y: 40.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__I",
    width: 35.2,
    height: 35.2,
    x: 671.4,
    y: 60.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__J",
    width: 35.2,
    height: 35.2,
    x: 671.4,
    y: 80.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__K",
    width: 35.2,
    height: 35.2,
    x: 691.4,
    y: 100.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__L",
    width: 35.2,
    height: 35.2,
    x: 691.4,
    y: 120.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__M",
    width: 35.2,
    height: 35.2,
    x: 711.4,
    y: 140.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__N",
    width: 35.2,
    height: 35.2,
    x: 711.4,
    y: 160.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__O",
    width: 35.2,
    height: 35.2,
    x: 731.4,
    y: 160.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__P",
    width: 35.2,
    height: 35.2,
    x: 751.4,
    y: 160.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__Q",
    width: 35.2,
    height: 35.2,
    x: 771.4,
    y: 160.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__R",
    width: 35.2,
    height: 35.2,
    x: 791.4,
    y: 160.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__S",
    width: 35.2,
    height: 35.2,
    x: 1051.4,
    y: 40.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__T",
    width: 35.2,
    height: 35.2,
    x: 1071.4,
    y: 40.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__U",
    width: 35.2,
    height: 35.2,
    x: 1071.4,
    y: 60.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__V",
    width: 35.2,
    height: 35.2,
    x: 1091.4,
    y: 60.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__W",
    width: 35.2,
    height: 35.2,
    x: 1111.4,
    y: 60.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__X",
    width: 35.2,
    height: 35.2,
    x: 1131.4,
    y: 60.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__Y",
    width: 35.2,
    height: 35.2,
    x: 1131.4,
    y: 80.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__Z",
    width: 35.2,
    height: 35.2,
    x: 1131.4,
    y: 100.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__aa",
    width: 35.2,
    height: 35.2,
    x: 1131.4,
    y: 160.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__ab",
    width: 35.2,
    height: 35.2,
    x: 1131.4,
    y: 180.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__ac",
    width: 35.2,
    height: 35.2,
    x: 1131.4,
    y: 200.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__ad",
    width: 35.2,
    height: 35.2,
    x: 1151.4,
    y: 200.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__ae",
    width: 35.2,
    height: 35.2,
    x: 1171.4,
    y: 200.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__af",
    width: 35.2,
    height: 35.2,
    x: 1191.4,
    y: 200.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__ag",
    width: 35.2,
    height: 35.2,
    x: 1191.4,
    y: 220.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__ah",
    width: 35.2,
    height: 35.2,
    x: 1191.4,
    y: 240.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__ai",
    width: 35.2,
    height: 35.2,
    x: 1191.4,
    y: 260.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__aj",
    width: 35.2,
    height: 35.2,
    x: 1211.4,
    y: 260.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__ak",
    width: 1756.8,
    height: 603.8,
    x: -158.9,
    y: -33.9,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 16.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_8963_222975",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect2_foregroundBlur_8963_222975",
    stdDeviation: 13.95
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__am",
    width: 35.2,
    height: 35.2,
    x: 1131.4,
    y: 140.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__an",
    width: 35.2,
    height: 35.2,
    x: 251.4,
    y: 360.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__ao",
    width: 35.2,
    height: 35.2,
    x: 1131.4,
    y: 120.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__ap",
    width: 35.2,
    height: 35.2,
    x: 1172.4,
    y: 440.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__aq",
    width: 35.2,
    height: 35.2,
    x: 1152.4,
    y: 440.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__ar",
    width: 35.2,
    height: 35.2,
    x: 1131.4,
    y: 440.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hero_svg__as",
    width: 35.2,
    height: 35.2,
    x: 711.4,
    y: 120.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.27451 0 0 0 0 0.854902 0 0 0 0 0.645961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.755518 0 0 0 0 1 0 0 0 0 0.976899 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_8963_222975",
    result: "effect2_dropShadow_8963_222975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_8963_222975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 268 -720.5 0 719.5 268)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__al",
    x1: -125,
    x2: 1555.38,
    y1: 402,
    y2: 169.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#111",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopColor: "#111",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111",
    stopOpacity: 0
  })))));
};
export default SvgHero;